module.exports = __webpack_public_path__ + "img/发现相框.88c4565e.png";